var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewPatientsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 52,
    fill: "#ACACAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    transform: "translate(-1084 -167)",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1059,
    y: -22,
    width: 1536,
    height: 100,
    rx: 9.94788,
    fill: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7144 10.0773C27.9331 10.599 30.1181 13.6312 29.5954 16.8487C29.0737 20.0662 26.0414 22.2515 22.824 21.7297C19.6053 21.208 17.4203 18.1757 17.943 14.9582C18.4647 11.7396 21.497 9.55455 24.7144 10.0773Z",
    fill: "#C2D6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5384 32.4864C34.5373 33.0624 34.0697 33.5288 33.4949 33.5311H14.0435C13.4687 33.5288 13.0011 33.0624 13 32.4864C13 28.6387 15.0531 25.0839 18.3846 23.1604C21.716 21.2361 25.8225 21.2361 29.1538 23.1604C32.4852 25.0837 34.5385 28.6387 34.5385 32.4864H34.5384Z",
    fill: "#C2D6DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 9.5,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 26C29.3573 26 26 29.3573 26 33.5C26 37.6427 29.3573 41 33.5 41C37.6427 41 41 37.6427 41 33.5C41 29.3573 37.6427 26 33.5 26ZM33.5 28.4C33.9969 28.4 34.4 28.8031 34.4 29.3V32.6H37.7C38.1969 32.6 38.6 33.0031 38.6 33.5C38.6 33.9969 38.1969 34.4 37.7 34.4H34.4V37.7C34.4 38.1969 33.9969 38.6 33.5 38.6C33.0031 38.6 32.6 38.1969 32.6 37.7V34.4H29.3C28.8031 34.4 28.4 33.9969 28.4 33.5C28.4 33.0031 28.8031 32.6 29.3 32.6H32.6V29.3C32.6 28.8031 33.0031 28.4 33.5 28.4Z",
    fill: "#9BBCCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_56220",
    x: -1061,
    y: -22,
    width: 1540,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.307813 0 0 0 0 0.326577 0 0 0 0 0.375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_56220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_56220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    fill: "white",
    transform: "translate(-1084 -167)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPatientsIcon);
export default __webpack_public_path__ + "static/media/new-patients-icon.ac499f2a14ebc26238ecf35c755a14c9.svg";
export { ForwardRef as ReactComponent };